import styled from 'styled-components';

import { Button } from '../../element';

export const PayPrice = styled.div`
  font-weight: 700;
  text-align: center;
  margin-bottom: 5px;
`;

export const PayPriceCommission = styled.div`
  text-align: center;
  margin-bottom: 10px;
`;

export const PayButton = styled(Button)`
  width: 100%;
  height: 55px;

  & img {
    width: 45px;
  }
`;
